import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import plateBg from '../assets/img/shijian_geren_icon.png';

const Plate = styled.div`
  width: 84px;
  height: 77px;
  background: url("${plateBg}");
  background-size: 100%;
  padding-top: 10px;
`;

const Time = styled.div`
  font-size: 28px;
  color: white;
  line-height: 42px;
  text-align: center;
`;

const Date = styled.div`
  font-size: 15px;
  line-height: 1;
  color: #666;
  text-align: center;
  margin-top: 4px;
  white-space: nowrap;
`;

class DataTimePlate extends Component {
  render() {
    const { time, date } = this.props;
    return (
      <Plate>
        <Time>{time}</Time>
        <Date>{date}</Date>
      </Plate>
    );
  }
}

DataTimePlate.propTypes = {
  time: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};
DataTimePlate.defaultProps = {};

export default DataTimePlate;



// WEBPACK FOOTER //
// ./src/components/datetime-plate.jsx